export default "__VITE_ASSET__DyqGIvAX__"